import React from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import RenewalRow from 'components/vendors/renewal-row';

const Renewals = ({
  renewalDate,
  productServiceName,
  editing,
  handleDateChange,
}) => (
  <Container>
    <Glow>
      <Icon icon={IconNames.CALENDAR} iconSize={60} intent={Intent.PRIMARY} />
    </Glow>
    <RenewalRow
      renewalDate={renewalDate}
      productServiceName={productServiceName}
      editing={editing}
      handleDateChange={handleDateChange}
    />
  </Container>
);

const Container = styled.div`
  border: 1px solid ${colors.muted};
  border-radius: 3px;
  flex-basis: 45%;
  margin: 0 1rem;
  display: flex;
  justify-content: center;
  background: #fff;
  text-align: center;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  max-height: 20rem;
`;

const Glow = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 50px;
  background: #edf4fa;
  margin-bottom: 0.5rem;
`;

export default Renewals;
